import { Box, Heading, Image, Modal, ModalContent, ModalOverlay, SimpleGrid, useDisclosure } from '@chakra-ui/react';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';
import { usePropertiesModel } from '@common/models/PropertiesModel';
import { Keyboard, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import './styles.css';

type GalleryProps = {
  children?: React.ReactNode;
};

export const GalleryGrid: React.FC<GalleryProps> = () => {
  const { property } = usePropertiesModel();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [initialSlide, setInitialSlide] = React.useState(0);

  return (
    <Box onClick={onOpen}>
      <Heading fontFamily={FontFamily.HELVETICA_NOW_BOLD} fontWeight="normal" fontSize={['32px', '40px']} pb="50px">
        Gallery
      </Heading>
      <SimpleGrid columns={2} gap="30px">
        {property?.sfr?.info?.images?.map((image, index) => (
          <Box
            cursor={'pointer'}
            backgroundImage={image.url}
            backgroundRepeat="no-repeat"
            backgroundSize="cover"
            backgroundPosition={'center center'}
            borderRadius={'10px'}
            key={`image-${index}`}
            flex="1"
            onClick={() => setInitialSlide(index)}
            w={'160px'}
            h={'160px'}></Box>
        ))}
      </SimpleGrid>
      <Modal isCentered isOpen={isOpen} onClose={onClose} size="6xl">
        <ModalOverlay backgroundColor="blackAlpha.100" backdropFilter="blur(5px)" />
        <ModalContent bg="transparent" boxShadow={'none'}>
          <Box>
            <Swiper
              initialSlide={initialSlide}
              keyboard={true}
              loop={true}
              modules={[Keyboard, Pagination, Navigation]}
              navigation={true}
              pagination={{ clickable: true }}
              slidesPerView={1}
              spaceBetween={30}
              style={{
                backgroundColor: 'transparent',
              }}>
              {property?.sfr?.info?.images?.map((image, index) => (
                <SwiperSlide
                  key={`image-${index}`}
                  style={{
                    alignSelf: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                  }}>
                  <Image src={image.url} minH={['auto', 'auto', 'auto', '500px']} maxH={'80vh'} maxW="100%" />
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>
        </ModalContent>
      </Modal>
    </Box>
  );
};
